import { debounce } from 'lodash';
import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { Tooltip } from 'reactstrap';
import {
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Tooltip as TooltipShadcn,
} from 'components/ui/tooltip';

const TooltipReactStrap = (props) => {
  const { placement, idTarget, messageToolTip, children } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <div className='dzb-tooltip'>
      <div id={idTarget}>{children}</div>
      <Tooltip placement={placement} isOpen={tooltipOpen} target={idTarget} toggle={toggle}>
        {messageToolTip}
      </Tooltip>
    </div>
  );
};

TooltipReactStrap.defaultProps = {
  placement: 'right',
  idTarget: 'example',
  messageToolTip: '',
};

// Recommend use
// Guide: https://www.npmjs.com/package/react-tooltip
//* Use with react-virtualized
export const rebuildTooltip = debounce(() => ReactTooltip.rebuild(), 200, {
  leading: false,
  trailing: true,
});

export const TooltipReactTooltip = ({ children, messageToolTip, asChild, v2Options }) => {
  return (
    <TooltipProvider>
      <TooltipShadcn delayDuration={0}>
        <TooltipTrigger type='button' asChild={asChild}>
          {children}
        </TooltipTrigger>
        <TooltipContent side={v2Options?.side}>{messageToolTip}</TooltipContent>
      </TooltipShadcn>
    </TooltipProvider>
  );
};

export default TooltipReactStrap;
